import React from "react";
import { toast } from "react-toastify";
import QRCode from "qrcode.react";
import { SidebarOverlay, SidebarGlass } from "./styledComponents";

function DepositSidebar({
  sidebarDeposit,
  onClose,
  selectedDepositNetwork,
  depositNetworkOptions,
  isLoadingDepositNetwork,
  depositAddress,
  onNetworkChange,
}) {
  if (!sidebarDeposit) return null;

  return (
    <>
      <SidebarOverlay onClick={onClose} />
      <SidebarGlass>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <h3 style={{ margin: 0 }}>Deposit {sidebarDeposit.symbol}</h3>
          <button
            onClick={onClose}
            style={{
              background: "none",
              border: "1px solid #5ce9ff",
              color: "#5ce9ff",
              borderRadius: "8px",
              padding: "4px 8px",
              cursor: "pointer",
            }}
          >
            Close
          </button>
        </div>

        <div style={{ marginTop: "16px" }}>Network</div>
        {isLoadingDepositNetwork ? (
          <div style={{ marginTop: "8px", color: "#94a3b8", fontSize: "12px" }}>Loading networks...</div>
        ) : (
          <select
            value={selectedDepositNetwork || ""}
            onChange={(e) => onNetworkChange(e.target.value)}
            style={{
              width: "100%",
              padding: "8px",
              borderRadius: "8px",
              marginTop: "4px",
              background: "#0b1220",
              color: "#e5e7eb",
              border: "1px solid #1f2937",
            }}
          >
            {depositNetworkOptions.length > 0 ? (
              depositNetworkOptions.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))
            ) : (
              <option value="">No networks available</option>
            )}
          </select>
        )}

        <div style={{ marginTop: "16px" }}>Address</div>
        <input
          value={depositAddress || ""}
          readOnly
          style={{
            width: "100%",
            padding: "8px",
            marginTop: "4px",
            borderRadius: "8px",
            border: "1px solid #1f2937",
            background: "#0b1220",
            color: "#94a3b8",
            cursor: "not-allowed",
          }}
          placeholder={isLoadingDepositNetwork ? "Loading..." : "No address available"}
        />

        {depositAddress && (
          <div
            style={{
              marginTop: "20px",
              padding: "18px",
              borderRadius: "16px",
              background: "rgba(92,233,255,0.08)",
              border: "1px solid rgba(92,233,255,0.35)",
              boxShadow: "0 0 25px rgba(92,233,255,0.25)",
            }}
          >
            <div style={{ display: "flex", justifyContent: "center", marginBottom: "12px" }}>
              <QRCode
                value={depositAddress}
                size={180}
                level="H"
                renderAs="canvas"
                style={{ borderRadius: "12px" }}
              />
            </div>
            <div style={{ marginTop: "12px", fontSize: "12px", textAlign: "center", color: "#5ce9ff" }}>
              Address: {depositAddress.length > 20 ? `${depositAddress.slice(0, 10)}...${depositAddress.slice(-8)}` : depositAddress}
            </div>
            <button
              onClick={() => {
                if (depositAddress) {
                  navigator.clipboard.writeText(depositAddress);
                  toast.success("Address copied to clipboard");
                }
              }}
              style={{
                marginTop: "10px",
                width: "100%",
                padding: "8px",
                borderRadius: "8px",
                background: "#5ce9ff",
                border: "none",
                color: "#001018",
                cursor: "pointer",
                fontWeight: 600,
              }}
            >
              Copy Address
            </button>
          </div>
        )}
      </SidebarGlass>
    </>
  );
}

export default DepositSidebar;

